'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2017/2/10.
                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopAnnouncement = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    // console.log(params);
    promises.push(dispatch((0, _background.changeHeaderText)('商户上线须知')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ShopAnnouncement, _Component);

  function ShopAnnouncement() {
    (0, _classCallCheck3.default)(this, ShopAnnouncement);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ShopAnnouncement).call(this));
  }

  (0, _createClass3.default)(ShopAnnouncement, [{
    key: 'render',
    value: function render() {
      var styles = require('./ShopAnnouncement.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.loginPic },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/center-geren/denglu.jpg',
            alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.loginMes },
          _react2.default.createElement(
            'div',
            { className: styles.loginH1 },
            '艺品网上线商户信息准备列项'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.bottomContainer },
            _react2.default.createElement(
              'h3',
              null,
              '一、企业资质信息'
            ),
            _react2.default.createElement(
              'p',
              null,
              '1、企业营业执照副本复印件（根据2014年10月1日生效的《企业经营异常名录管理暂行办法》，需确保未在企业经营异常名录中且所售商品属于经营范围内；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '2、企业税务登记证复印件（未更换“三证合一”证照，税务登记证上要有国税章和地税章，无地税需提供地区停止地税证明）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '3、银行开户许可证复印件；（须有中国人民银行盖章，法人代表与营业执照一致，不一致请提供工商局出具的变更证明）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '4、法定代表人身份证正反面复印件。'
            ),
            _react2.default.createElement(
              'h3',
              null,
              ' 二、大师工作室资质信息'
            ),
            _react2.default.createElement(
              'p',
              null,
              '1、大师荣誉称号证书复印件；'
            ),
            _react2.default.createElement(
              'p',
              null,
              ' 2、大师职称证书复印件；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '3、大师工作室营业执照副本复印件（根据2014年10月1日生效的《企业经营异常名录管理暂行办法》，需确保未在企业经营异常名录中且所售商品属于经营范围内；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '4、银行开户许可证复印件；（须有中国人民银行盖章，法人代表与营业执照一致，不一致请提供工商局出具的变更证明）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '5、大师个人身份证正反面复印件。'
            ),
            _react2.default.createElement(
              'h3',
              null,
              '三、企业/大师工作室信息'
            ),
            _react2.default.createElement(
              'p',
              null,
              '1、店铺信息：商户名称、联系方式、地址、邮箱；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '2、店铺的介绍（100-300字）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '3、所获荣誉（相关证书电子扫描图片）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '4、店铺经营类别及介绍内容（每一产品品类介绍100字内）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '5、店铺logo图片（图片清晰大小不小于500KB，为利于编辑展示请尽量提供矢量素材eps、ai格式）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '6、店铺的环境照片：外景照片，内景照片共5张（图片清晰、具有一定艺术性，图片大小2MB-10MB，图片格式JPEG、BMP 1920*796像素）；'
            ),
            _react2.default.createElement(
              'p',
              null,
              '7、具有代表性的经营理念、商家宣言、服务宗旨（100字内）。'
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/contactus/callus' },
              '联系我们'
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ShopAnnouncement;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ShopAnnouncement;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ShopAnnouncement/ShopAnnouncement.js
 ** module id = 1541
 ** module chunks = 0
 **/